__turbopack_context__.v({
  "ProseMirror": "ProjectTeaserLatestMessage-module-scss-module__S63TtW__ProseMirror",
  "body": "ProjectTeaserLatestMessage-module-scss-module__S63TtW__body",
  "clickable": "ProjectTeaserLatestMessage-module-scss-module__S63TtW__clickable",
});
